
<template>
  <v-overlay v-if="loading"
             :absolute="true"
             z-index="100">
    <v-progress-circular size="60"
                         color="white"
                         indeterminate>
    </v-progress-circular>
  </v-overlay>
</template>


<script>
export default {
  name: "OverlayLoading",
  props: ["loading"],
  components: {},

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>
